import React, { useMemo } from 'react'
import { Typography } from 'antd'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import _ from 'lodash'
import SortableTable, {
  DragHandler
} from '../../../../../Common/SortableTable/SortableTable'
import {
  COLUMN,
  getRemovedExtraModelsFromForm
} from '../helper'
import styles from '../index.css'
import { UPDATE_LISTING_FORM_KEY } from '../../../../../../constants/proposalTypes'

const { Paragraph } = Typography

const getColumns = (isAttrModelExist, shortTitleFeatureToggle) => [
  {
    key: 'sortableIcon',
    width: 50,
    align: 'center',
    render: (text, record) => {
      const { index } = record
      return (
        <DragHandler
          id={index}
          disabled
        />
      )
    }
  },
  {
    title: '商品編號 / 商品名稱',
    width: 200,
    dataIndex: COLUMN.NAME,
    key: COLUMN.NAME,
    render: (text, record, index) => {
      const {
        [COLUMN.ID]: id,
        [COLUMN.NAME]: name
      } = record
      return (
        <>
          <div>{id}</div>
          <Paragraph ellipsis={{ rows: 2 }}>
            {name}
          </Paragraph>
        </>
      )
    }
  },
  {
    title: shortTitleFeatureToggle ? '贈品短標題 / 贈品完整名稱' : '贈品完整名稱',
    width: 200,
    dataIndex: COLUMN.DISPLAY_NAME,
    key: COLUMN.DISPLAY_NAME,
    render: (text, record, index) => {
      const { [COLUMN.GROUP_NAME]: groupName, isNoAttr } = record
      const attrName = _.get(record, COLUMN.ATTR_NAME)
      const shortTitle = _.get(record, COLUMN.SHORT_TITLE)

      const fullName = isNoAttr ? attrName : groupName

      return (
        <>
          {
            shortTitleFeatureToggle && (
              <>
                {shortTitle}
                <br />
              </>
            )}
          {fullName}
        </>
      )
    }
  },
  {
    title: isAttrModelExist ? '贈品屬性名稱' : '',
    width: 200,
    dataIndex: COLUMN.ATTR_NAME,
    key: COLUMN.ATTR_NAME,
    render: (text, record, index) => {
      const { isNoAttr } = record
      if (isNoAttr) {
        return null
      }

      const attrName = _.get(record, COLUMN.ATTR_NAME)
      return attrName
    }
  },
  {
    title: '庫存',
    width: 90,
    dataIndex: COLUMN.STOCK,
    key: COLUMN.STOCK,
    align: 'right',
    render: (text, record, index) => {
      const {
        [COLUMN.STOCK]: stock
      } = record
      return stock
    }
  },
  {
    title: '供應商商品料號',
    width: 120,
    dataIndex: COLUMN.PART_NO,
    key: COLUMN.PART_NO,
    render: (text, record, index) => {
      const {
        [COLUMN.PART_NO]: partNo
      } = record
      return partNo
    }
  },
  {
    key: 'action',
    width: 110,
    align: 'right',
    render: (text, record, index) => {
      return null
    }
  }
]

const ReadOnlyExtraModelTable = props => {
  const {
    tableType,
    form,
    shortTitleFeatureToggle
  } = props

  const [data, isAttrModelExist] = useMemo(() => {
    // 從 diff removed 裡組出刪除的 extra models
    const newData = getRemovedExtraModelsFromForm(form, tableType)
    const isAttrModelExist = _.some(newData, item => !item.isNoAttr)
    return [newData, isAttrModelExist]
  }, [tableType, form])

  return (
    <SortableTable
      data={data}
      columns={getColumns(isAttrModelExist, shortTitleFeatureToggle)}
      className={styles.table}
    />
  )
}

const ReadOnlyExtraModelTableWithRedux = connect((state, props) => {
  const form = getFormValues(UPDATE_LISTING_FORM_KEY)(state)
  const reduxProps = {
    form,
    shortTitleFeatureToggle: props.shortTitleFeatureToggle
  }
  return reduxProps
})(ReadOnlyExtraModelTable)

export default ReadOnlyExtraModelTableWithRedux
